export default __webpack_public_path__ + "static/media/T3_360.8754976a.jpg";